"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Index_1 = require("../Index");
const helpers_1 = require("../../lib/helpers");
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const FormContext_1 = require("../../contexts/FormContext");
const Icon_1 = __importDefault(require("../Util/Icon"));
const Journey_1 = require("../../lib/Journey");
const Input_1 = __importDefault(require("./Base/Input"));
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const inputs_1 = require("../../lib/inputs");
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
function generateId() {
    return (Date.now() + (Math.random() * 1000));
}
function convertFileResultsSimple(value, resolveFileResult) {
    const valueArray = Array.isArray(value) ? value : [value];
    resolveFileResult = resolveFileResult !== null && resolveFileResult !== void 0 ? resolveFileResult : ((value) => ({
        src: value,
        id: generateId(),
        name: '',
    }));
    return valueArray.filter((v) => !!v && v !== '').map((v) => resolveFileResult(v));
}
function convertFileResults(value) {
    return new Promise((resolve, reject) => {
        if (value instanceof FileList) {
            const newFileResults = [];
            const fileCount = ([...value]).length;
            ([...value]).forEach((file) => {
                inputs_1.readFile(file, (src, name) => {
                    newFileResults.push({ src, name, id: generateId(), file });
                    if (fileCount === newFileResults.length) {
                        resolve(newFileResults);
                    }
                });
            });
        }
        else if (value instanceof File) {
            const fr = inputs_1.readFile(value, (src, name) => resolve([{ src, name, id: generateId(), file: value }]));
            return () => {
                fr.abort();
            };
        }
    });
}
const MultiFileInput = (props) => {
    var _a, _b, _c;
    const { help, accept, onFileAdd, onFileRemove, resolveFileResult } = props;
    const { formData, setFormData } = react_1.useContext(FormContext_1.FormContext);
    const value = (_a = props.value) !== null && _a !== void 0 ? _a : formData[(_b = props.name) !== null && _b !== void 0 ? _b : ''];
    const inputRef = react_1.useRef(null);
    const placeholder = (_c = props.placeholder) !== null && _c !== void 0 ? _c : 'Add a file';
    const [fileResults, setFileResults] = react_1.useState(convertFileResultsSimple(value, resolveFileResult));
    react_1.useEffect(() => {
        setFileResults(convertFileResultsSimple(value, resolveFileResult));
    }, [resolveFileResult, value]);
    react_1.useEffect(() => {
        if (inputRef.current && !value && inputRef.current.value !== '') {
            // force reset the input file, otherwise uploading the same file again will not trigger an onChange.
            inputRef.current.value = '';
        }
    }, [value]);
    const onClickHandle = react_1.useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const onRemoveImgClick = react_1.useCallback((e, fileResult) => __awaiter(void 0, void 0, void 0, function* () {
        const propName = props.name;
        const fileToBeRemoved = yield (onFileRemove === null || onFileRemove === void 0 ? void 0 : onFileRemove(fileResult, value));
        setFormData((formData) => (Object.assign(Object.assign({}, formData), { [propName]: formData[propName].filter((v) => v !== fileToBeRemoved) })));
    }), [onFileRemove, props.name, setFormData, value]);
    const [loading, setLoading] = react_1.useState(false);
    const beforeFormChange = (e, prevForm) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const fileResults = yield convertFileResults(e.target.files);
        const eventValue = yield Promise.all(fileResults.map((fileResult) => onFileAdd(fileResult)));
        setLoading(false);
        const newValue = [...prevForm[props.name], ...eventValue];
        return Object.assign(Object.assign({}, prevForm), { [props.name]: newValue });
    });
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement("div", { onClick: onClickHandle },
            react_1.default.createElement(InputLabel_1.default, null),
            loading && (react_1.default.createElement("div", { className: "absolute top-0 left-0 z-20 w-full h-full flex justify-center items-center bg-opacity-10 bg-black" },
                react_1.default.createElement(Spinner_1.default, null))),
            react_1.default.createElement("div", { className: "j-file-list" },
                fileResults.map((fileResult) => {
                    var _a;
                    return (react_1.default.createElement("div", { className: "j-file", key: fileResult.id },
                        react_1.default.createElement("img", { alt: "file input img", className: "j-file-img", src: fileResult.src }),
                        react_1.default.createElement("div", { className: classnames_1.default('j-file-desc', { 'justify-center': !fileResult.name }) },
                            fileResult.name ? (react_1.default.createElement("span", { className: "j-file-name" }, (_a = fileResult.name) !== null && _a !== void 0 ? _a : 'Image')) : null,
                            react_1.default.createElement(Index_1.Button, { className: "j-file-close-button", onClick: (e) => {
                                    e.stopPropagation();
                                    return onRemoveImgClick(e, fileResult);
                                } },
                                react_1.default.createElement(Icon_1.default, { src: Journey_1.Journey.icons().CLOSE })))));
                }),
                react_1.default.createElement("div", { className: "j-file j-placeholder" },
                    react_1.default.createElement(Index_1.Button, null, placeholder))),
            help ? (react_1.default.createElement("div", { className: "j-help" }, help)) : null,
            react_1.default.createElement(Input_1.default, Object.assign({}, helpers_1.without(props, ['className', 'value']), { accept: accept, ref: inputRef, beforeFormChange: beforeFormChange, multiple: true, type: "file" }))),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-multi-file-input', MultiFileInput);
